/*
**検査9解答
** 36ページ
*/
const answer={
1:"C",
2:"B",
3:"D",
4:"D",
5:"A",
6:"C",
7:"A",

// 37ページ
8:"B",
9:"A",
10:"C",
11:"A",
12:"C",
13:"A",
14:"C",

// 38ページ
15:"A",
16:"D",
17:"B",
18:"D",
19:"B",
20:"D",
21:"A",

// 39ページ
22:"B",
23:"B",
24:"D",
25:"C",
26:"B",
27:"C",
28:"D",
};

export default answer;